<template>
	<v-parallax class="mt-4" :src="parallaximg" height="300" offset="100%" type="fixed">
		<!-- <v-layout class="pa-2" align-center column justify-center fill-height> -->
		<!-- <h1  class="white--text keep-spaces">کسب و کار خود را به راحتی مدیریت کنید</h1> -->
		<!-- <h4  class="white--text">با ما تماس بگیرید</h4> -->
		<!-- </v-layout> -->
		<v-row align="center" justify="center">
			<v-col class="text-center" >
				<!-- <h1 class="display-1 font-weight-thin mb-4 keep-spaces" >کسب و کار خود را به راحتی مدیریت کنید</h1> -->
				<h1 class="mb-4 white--text keep-spaces" >کسب و کار خود را به راحتی مدیریت کنید</h1>
				<!-- <h4 class="subheading">Build your application today!</h4> -->
			</v-col>
		</v-row>
	</v-parallax>
</template>

<script>
	// import { FluxParallax } from "vue-flux";

	export default {
		name: "HomeParallax",
		data() {
			return {
				parallaximg: require("@/assets/img/home-parallax.jpg"),
			};
		},
		// components: {
		// 	FluxParallax,
		// },
	};
</script>

<style>
	.keep-spaces {
		white-space: pre-wrap;
	}
</style>
